import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './Button';
interface CtaButtonProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  target?: string;
}
export function scrollToTarget(target = 'ofertas') {
  document.getElementById(target)?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function CtaButton({
  label = 'VER LAS OFERTAS',
  size = 'lg',
  className = '',
  target = 'ofertas'
}: CtaButtonProps) {
  return <Button size={size} className={className} onClick={() => scrollToTarget(target)} data-id="element-251">
      {label} <ArrowRight className="ml-2 w-5 h-5" data-id="element-252" />
    </Button>;
}